import * as Yup from 'yup';

export const productDetailAttributesValidationSchema = Yup.object().shape({
    attributes: Yup.array().of(
        Yup.object().shape({
            id: Yup.number().nullable(),
            values: Yup.object(),
        })
    ),
});
